import Vue from 'vue'
import i18n from '@/i18n/i18n'
import app from '@/main'

export const notifyServerError = error => {
  let text = '',
    code = '500'
  if (error.response !== undefined) {
    if (error.response.data.message.indexOf('@') > -1) {
      const t = error.response.data.message.split('@')
      text = i18n.t('server.' + t[0], t[1].split(':'))
    } else text = i18n.t('server.' + error.response.data.message)
  } else {
    text = i18n.t(error.message ? `server.${error.message}` : 'Internal server error')
  }
  app.$vs.notify({
    title: `${i18n.t('forms.error')} ( ${app.$filters.persian_digits(code)} )`,
    text,
    iconPack: 'feather',
    icon: 'icon-alert-circle',
    color: 'danger',
    time: 8000
  })
}
Vue.prototype.$notifyServerError = notifyServerError

export const notifySuccess = (text, title = null) => {
  app.$vs.notify({
    title: title ? title : text,
    text: title ? text : null,
    iconPack: 'feather',
    icon: 'icon-check',
    color: 'success',
    time: 8000
  })
}
Vue.prototype.$notifySuccess = notifySuccess

export const notifyWarning = (text, title = null) => {
  app.$vs.notify({
    title: title ? title : text,
    text: title ? text : null,
    iconPack: 'feather',
    icon: 'icon-alert-circle',
    color: 'warning',
    time: 8000
  })
}
Vue.prototype.$notifyWarning = notifyWarning

export const notifyError = (text, title = null) => {
  app.$vs.notify({
    title: title ? title : text,
    text: title ? text : null,
    iconPack: 'feather',
    icon: 'icon-alert-circle',
    color: 'danger',
    time: 8000
  })
}
Vue.prototype.$notifyError = notifyError
